import { render, staticRenderFns } from "./WorkDetailType.vue?vue&type=template&id=55b45a30&scoped=true"
import script from "./WorkDetailType.vue?vue&type=script&lang=js"
export * from "./WorkDetailType.vue?vue&type=script&lang=js"
import style0 from "./WorkDetailType.vue?vue&type=style&index=0&id=55b45a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b45a30",
  null
  
)

export default component.exports